import React from "react";
import { cn } from "@/lib/utils";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

const WaveInput = React.forwardRef(({ label, className, ...props }, ref) => {
    return (
        <div className="grid w-full items-center gap-1.5 mb-4">
            <Label>{label}</Label>
            <Input ref={ref} className={className} {...props} />
        </div>
    );
});

WaveInput.displayName = "WaveInput";

export default WaveInput;
